import { useEffect } from "react";
import { useNavigation, useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    // Only scroll when navigation is complete
    if (navigation.state === "idle") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname, navigation.state]);

  return null;
};

export default ScrollToTop;
